import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useGetCurrentUserInfoQuery, useGetUserIdQuery, usePostUserChangeStatusMutation } from '../../store/api/userApi'
import { hideRejectDialog } from '../../store/slice/dialogSlice'
import {
  useGetRequestByInfoQuery,
  usePostRequestChangeDetailStatusMutation,
  usePostRequestChangeMainStatusMutation,
  useRejectReasonsQuery,
} from '../../store/api/requestApi'
import { MultilineTextBox } from '../TextBox'
import { useGetVendorCardQuery, usePostVendorChangeStatusMutation, usePostVendorRfqChangeStatusMutation } from '../../store/api/vendorApi'
import { offRefreshButton, onRefreshButton } from '../../store/slice/buttonSlice'
import SelectBox from '../CustomInputs/Select/SelectBox'
import { showErrorToast, showSuccessToast } from '../../constToast/constToast'
import { usePostOrderChangeStatusMutation } from '../../store/api/orderApi'
import { head } from 'lodash'
import { usePostChangeInvoiceStatusMutation, useRejectReasonsForInvoiceQuery } from '../../store/api/invoiceApi'
import { updateRefetchData } from '../../store/slice/otherSlice'
import { updateSelectedMaterialData } from '../../store/slice/persistSlice'
import SelectForm from '../SelectBox/SelectForm'
import { useForm } from 'react-hook-form'
import { updateUserData, updateVendorData } from '../../store/slice/mainToCardSlice'
import { useGetRFQByIdQuery } from '../../store/api/rfqsApi'

const RejectDialog = ({ data, callback }) => {
  const navigate = useNavigate()
  const { handleSubmit, control, formState: { errors }, reset } = useForm({ mode: 'onBlur' });
  const { data: userInfoData } = useGetCurrentUserInfoQuery();

  const dispatch = useDispatch()
  const handleClose = () => {
    dispatch(hideRejectDialog())
    setComment('')
    reset({
      rejectReasonId: ''
    });
  }
  const open = useSelector((state) => state.dialogSlice.rejectDialog)
  const url = useLocation().pathname
  const { data: rejectReasonsData } = useRejectReasonsQuery()
  const { data: rejectReasonsForInvoiceData } = useRejectReasonsForInvoiceQuery()

  const userData = useSelector((state) => state.mainToCard.userData)
  const orderPersistData = useSelector((state) => state.persistSlice.orderPersistData)
  const requestDataSlice = useSelector((state) => state.persistSlice.requestData)
  const vendorData = useSelector((state) => state.mainToCard.vendorData)
  const selectedMaterialData = useSelector((state) => state.persistSlice.selectedMaterialData)
  const paymentDataSlice = useSelector((state) => state.persistSlice.paymentData)
  const paymentCardDataSlice = useSelector((state) => state.paymentSlice.paymentCardDataSlice)
  const materialTableDataSlice = useSelector((state) => state.persistSlice.materialData)
  const requestDetailsData =
    selectedMaterialData &&
    selectedMaterialData?.map((item) => ({ requestDetailId: item?.requestDetailId, sequence: item?.sequence }))

  const paymentCardDataSliceHeader = paymentCardDataSlice?.header
  const buData = useSelector((state) => state.persistSlice.buData)
  const { data: currentUserData } = useGetCurrentUserInfoQuery()

  const [comment, setComment] = useState('')
  const [rejectReasonId, setRejectReasonId] = useState(1)

  const [addUserStatus] = usePostUserChangeStatusMutation()
  const [postChangeMainStatus, { isLoading: postChangeMainStatusLoading }] = usePostRequestChangeMainStatusMutation()
  const [postChangeDetailStatus, { isLoading: postChangeDetailStatusLoading }] =
    usePostRequestChangeDetailStatusMutation()
  const [postVendorChangeStatus] = usePostVendorChangeStatusMutation()
  const [postChangeInvoiceStatus] = usePostChangeInvoiceStatusMutation()
  const invoiceMain = useSelector((state) => state.mainToCard.invoiceMain)
  const [postRFQVendorChangeStatus, { isLoading: postRFQVendorChangeStatusLoading }] = usePostVendorRfqChangeStatusMutation()

  let content, action, name

  const handleRefresh = () => {
    dispatch(onRefreshButton())
    setTimeout(() => {
      dispatch(offRefreshButton(false))
    }, 1)
  }
  const { dataId } = useParams()
  const { data: userInfo } = useGetUserIdQuery(dataId)
  const { data: vendorInfo } = useGetVendorCardQuery(dataId)
  const { data: requestData } = useGetRequestByInfoQuery({
    requestMainId: dataId,
    businessUnitId: buData != null ? buData : currentUserData?.data?.defaultBusinessUnitId,
  })

  const rfqMainIdSlice = useSelector((state) => state.bidsSlice.rfqMainIdSlice)
  const { data: rfqData } = useGetRFQByIdQuery(rfqMainIdSlice)

  const vendorRfqData = useSelector((state) => state.mainToCard.vendorRfqData)

  const dayjs = require('dayjs')
  const today = dayjs(new Date())
  useEffect(() => {
    dispatch(
      updateSelectedMaterialData([
        materialTableDataSlice?.find((item) => item?.lineNo == selectedMaterialData?.map((item) => item?.lineNo)),
      ])
    )
  }, [materialTableDataSlice])

  const orderData = useSelector((state) => state.mainToCard.orderData)
  const [postOrderChangeStatus] = usePostOrderChangeStatusMutation()

  const handlePostVendorChange = async () => {
    const data = await postVendorChangeStatus({
      vendorId: vendorData[0]?.vendorId,
      approveStatusId: 2,
      sequence: vendorData[0]?.sequence,
      comment: comment,
    })
    if (data?.data?.data) {
      showSuccessToast(`Succesfully`)
    } else {
      showErrorToast('Error')
    }
    setComment('')
    handleClose()
    handleRefresh()
    dispatch(updateVendorData([]));
  }

  const invoiceBuData = useSelector((state) => state.invoiceSlice.invoiceBuData)


  async function handleInvoiceReject(data) {

    const res = await postChangeInvoiceStatus({
      invoiceRegisterIds: invoiceMain?.map((item) => {
        return {
          invoiceRegisterId: item?.invoiceRegisterId,
          sequence: item?.sequence,
          inMaxSequence: item?.inMaxSequence,
          invoiceTypeId: item?.invoiceType,
        }
      }),
      approveStatus: 2,
      businessUnitId: invoiceBuData,
      comment,
      rejectReasonId: data.rejectReasonId
    })
    setComment('')
    handleClose()
    handleRefresh()

    if (res?.data?.statusCode === 200) {
      showSuccessToast(`${invoiceMain[0] && invoiceMain?.map(x => x.invoiceNo).join(', ')} rejected`)
    } else {
      showErrorToast('Error')
    }
  }

  switch (url) {
    // USERS
    case '/users':
      name = <>{userData[0]?.userName}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            addUserStatus([
              {
                id: userData[0]?.id,
                sequence: userData[0]?.sequence,
                approveStatus: 2,
                comment,
              },
            ])
            setComment('')
            dispatch(updateUserData([]));
            handleClose()
            showSuccessToast('Success')
          }}
        >
          Reject
        </Button>
      )
      break
    case `/users/${userInfo?.data?.id}`:
      name = <>{userInfo?.data?.userName}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            addUserStatus([
              {
                id: userInfo?.data?.id,
                approveStatus: 2,
                comment,
                sequence: Number(localStorage.getItem('userSequence')),
              },
            ])
            navigate('/users')
            handleClose()
            showSuccessToast('Success')
          }}
        >
          Reject
        </Button>
      )
      break

    // REQUESTS
    case '/requests':
      name = <>{requestDataSlice && requestDataSlice?.map((item) => item.requestNo).join(', ')}</>
      content = (
        <Box sx={{ display: 'grid', gap: '15px' }}>
          <SelectBox
            label={'Reject reason'}
            onChange={(e) => setRejectReasonId(e?.rejectReasonId)}
            data={rejectReasonsData?.data}
            valueKey={'rejectReasonId'}
            position={'relative'}
            labelKey={'reasonName'}
          />
          <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
        </Box>
      )
      action = (
        <Button
          variant="contained"
          disabled={postChangeMainStatusLoading}
          onClick={async () => {
            const requestDataArray = requestDataSlice?.map((item) => ({
              requestMainId: item.requestMainId,
              requestNo: item.requestNo,
              sequence: item.sequence,
            }))

            const data = await postChangeMainStatus({
              requestDatas: requestDataArray,
              approveStatus: 2,
              rejectReasonId,
              comment,
              businessUnitName: requestDataSlice?.[0].businessUnitName,
            })

            if (data?.data?.statusCode === 200) {
              showSuccessToast('Succesfully')
            }

            handleRefresh()
            setComment('')
            handleClose()
          }}
        >
          Reject
        </Button>
      )
      break


    // Request Detail
    case `/requests/${requestData?.data?.requestMainId}`:
      name = <>Line No {selectedMaterialData && selectedMaterialData.map((item) => item?.lineNo).join(', ')}</>
      content = (
        <Box sx={{ display: 'grid', gap: '15px' }}>
          <SelectBox
            label={'Reject reason'}
            onChange={(e) => setRejectReasonId(e?.rejectReasonId)}
            data={rejectReasonsData?.data}
            valueKey={'rejectReasonId'}
            position={'relative'}
            labelKey={'reasonName'}
          />
          <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
        </Box>
      )
      action = (
        <Button
          variant="contained"
          disabled={postChangeDetailStatusLoading}
          onClick={async () => {
            const data = await postChangeDetailStatus({
              requestDetails: requestDetailsData,
              approveStatus: 2,
              comment,
              businessUnitName: requestData?.data?.businessUnitName,
              rejectReasonId,
            })
            if (data?.data?.statusCode === 200) {
              showSuccessToast('Succesfully')
            }
            handleRefresh()
            setComment('')
            handleClose()
          }}
        >
          Reject
        </Button>
      )
      break

    // Bids detail
    case `/bids/${dataId}`:
      name = <></>
      content = (
        <Box sx={{ display: 'grid', gap: '15px' }}>
          <strong>Are you sure, you want to reject {rfqData?.data?.rfqNo}?</strong>
          <SelectBox
            label={'Reject reason'}
            onChange={(e) => setRejectReasonId(e?.rejectReasonId)}
            data={rejectReasonsData?.data}
            valueKey={'rejectReasonId'}
            position={'relative'}
            labelKey={'reasonName'}
          />
          <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
        </Box>
      )
      action = (
        <Button
          variant="contained"
          disabled={rfqData?.data?.status == 2 || !(vendorRfqData[0]?.participationStatus == 'Issued' && dayjs(vendorRfqData[0]?.rfqDeadline).isAfter(today))}
          onClick={async () => {
            const data = await postRFQVendorChangeStatus({
              comment,
              rejectReasonId,
              rfqMainId: rfqData?.data?.id,
              status: 5,
              vendorCode: userInfoData?.data?.vendorCode,
            })
            if (data?.data?.statusCode === 200) {
              showSuccessToast('Succesfully')
            }
            handleRefresh()
            setComment('')
            handleClose()
            navigate(`/rfq-information`)
          }}
        >
          Reject
        </Button>
      )
      break


    // Vendors
    case '/vendors':
      name = <>{vendorData[0] ? vendorData[0]?.vendorName : ''}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button variant="contained" onClick={handlePostVendorChange}>
          Reject
        </Button>
      )
      break

    // Vendors
    case `/vendors/${vendorInfo?.data?.header?.vendorId}`:
      name = <>{vendorInfo?.data?.header?.vendorName}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            postVendorChangeStatus({
              vendorId: vendorInfo?.data?.header?.vendorId,
              sequence: vendorInfo?.data?.header?.sequence,
              approveStatusId: 2,
              comment,
            })
            setComment('')
            handleClose()
            navigate('/vendors')
            showSuccessToast('Succesfully')
          }}
        >
          Reject
        </Button>
      )
      break

    // Orders
    case '/orders':
      name = <>{orderData[0]?.orderNo}</>
      content = (
        <Box sx={{ display: 'grid', gap: '15px' }}>
          <SelectBox
            label={'Reject reason'}
            onChange={(e) => setRejectReasonId(e?.rejectReasonId)}
            data={rejectReasonsData?.data}
            valueKey={'rejectReasonId'}
            position={'relative'}
            labelKey={'reasonName'}
          />
          <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
        </Box>
      )
      action = (
        <Button
          variant="contained"
          onClick={() => {
            postOrderChangeStatus({
              orderMainId: orderData[0]?.orderMainId,
              approveStatusId: 2,
              sequence: orderData[0]?.sequence,
              comment: comment,
              rejectReasonId,
            })
            setComment('')
            handleClose()
            handleRefresh()
            dispatch(updateRefetchData())
            showSuccessToast('Succesfully')
          }}
        >
          Reject
        </Button>
      )
      break

    case `/orders/${dataId}`:
      name = <>{orderPersistData?.[0]?.orderNo}</>
      content = (
        <Box sx={{ display: 'grid', gap: '15px' }}>
          <SelectBox
            label={'Reject reason'}
            onChange={(e) => setRejectReasonId(e?.rejectReasonId)}
            data={rejectReasonsData?.data}
            valueKey={'rejectReasonId'}
            position={'relative'}
            labelKey={'reasonName'}
          />
          <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
        </Box>
      )
      action = (
        <Button
          variant="contained"
          onClick={() => {
            postOrderChangeStatus({
              orderMainId: orderPersistData?.[0]?.orderMainId,
              approveStatusId: 2,
              sequence: orderPersistData?.[0]?.sequence,
              comment: comment,
              rejectReasonId: null,
            })

            setComment('')
            handleClose()
            dispatch(updateRefetchData())
            showSuccessToast('Succesfully')
            navigate('/orders')
          }}
        >
          Reject
        </Button>
      )
      break

    // invoice register
    case '/invoice-register':
      name = <>{invoiceMain[0] && invoiceMain?.map(x => x.invoiceNo).join(', ')}</>
      content = (
        <Box sx={{ display: 'grid', gap: '15px' }}>


          <form onSubmit={handleSubmit(handleInvoiceReject)} noValidate id='form-vendorCard'>

            <SelectForm label='Reject reason' id='rejectReasonId' name='reasonName'
              control={control} errors={errors} disabled={false}
              data={rejectReasonsData?.data} dynamicField='rejectReasonId' required={true} />

          </form>


          {/* <SelectBox
            onChange={(e) => setRejectReasonId(e?.rejectReasonId)}
            data={rejectReasonsData?.data}
            valueKey={'rejectReasonId'}
            position={'relative'}
            labelKey={'reasonName'}
          /> */}
          <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
        </Box>
      )
      action = (
        <Button
          variant="contained"
          onClick={handleSubmit(handleInvoiceReject)}
        >
          Reject
        </Button>
      )
      break
    default:
      content = null
      break
  }

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Reject {name}</DialogTitle>
        <Divider />
        <DialogContent>{content}</DialogContent>
        <DialogActions>
          {action}
          <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default RejectDialog